/** @deprecated Quarantined legacy (WEB-8858) — moved out of the Angular tree so the ReactTemplates.elevio global survives Phase 6. Do not import in new code. */
'use strict';
import React from 'react';

const elevio = window.ReactCreateClass({
	render: function () {
		var style = { borderBottom: 'none' };
		if (this.props.sidebar) {
			if (this.props.text) {
				return (
					<span data-elevio-article={this.props.articleId} style={this.props.style}>
						{this.props.text}
					</span>
				);
			} else if (this.props.children) {
				return (
					<span data-elevio-article={this.props.articleId} style={style}>
						{this.props.children}
					</span>
				);
			}
			return (
				<b
					data-elevio-article={this.props.articleId}
					style={this.props.style}
					className="fa fa-question-circle"
				/>
			);
		}
		if (this.props.text) {
			return <span data-elevio-inline={this.props.articleId}>{this.props.text}</span>;
		} else if (this.props.children) {
			return (
				<span data-elevio-inline={this.props.articleId} style={style}>
					{this.props.children}
				</span>
			);
		}
		return (
			<b data-elevio-inline={this.props.articleId} style={this.props.style} className="fa fa-question-circle" />
		);
	}
});

// The global assignment stays until every consumer is converted (WEB-9512 removes it along with
// the shim's side-effect import). Until then both surfaces resolve to the same component.
ReactTemplates.elevio = elevio;

export default elevio;
